import { render } from "./BackgroundOverlay.vue?vue&type=template&id=7904f5fd&scoped=true"
import script from "./BackgroundOverlay.vue?vue&type=script&lang=js"
export * from "./BackgroundOverlay.vue?vue&type=script&lang=js"

import "./BackgroundOverlay.vue?vue&type=style&index=0&id=7904f5fd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7904f5fd"]])

export default __exports__